/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_profileCarousel", {
        options: {
            slickOptions: {
                arrows: true,
                autoplay: false,
                autoplaySpeed: 1000,
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 3,
                dots: false,
                rows: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: api.vars.scr.desktop,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                        },
                    },
                ],
                appendArrows: jQuery(".s-profile__carousel__toolbar .b-slick-arrows"),
            },
        },

        _create: function () {
            this.wrap = this.element;

            $(".s-profile__carousel__items", this.wrap).each((indx, el) => {
                $(el)
                    .on("init", (slick) => {
                        var dots = $(".slick-dots", $(slick.target));
                        api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed / 1000);
                    })
                    .slick(this.options.slickOptions)
                    .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                        var dots = $(".slick-dots", $(event.target));
                        api.fn.slickDotsFilled(dots, nextSlide);
                    });
            });
        },
    });
})(jQuery);
